import { useField } from 'formik';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText } from '@mui/material';

const MyRadioGroup = ({ label, options, ...props }) => {
  const [field, meta, helpers] = useField(props);

  return (
    <FormControl error={meta.touched && Boolean(meta.error)}>
      <FormLabel>{label}</FormLabel>
      <RadioGroup
        name={field.name}
        value={field.value || ''}
        onChange={(e) => helpers.setValue(e.target.value)}
        row
      >
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<Radio />}
            label={opt.label}
          />
        ))}
      </RadioGroup>
      {meta.touched && meta.error && <FormHelperText>{meta.error}</FormHelperText>}
    </FormControl>
  );
};

export default MyRadioGroup;
